import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="login-container">
      <div class="login-card">
        <div class="card-swatch-top"></div>
        <div class="brand-header">
          <div class="brand-logo"><img src="assets/logo_guido.png" alt="Rock&Rullo Logo" /></div>
          <h2>Rock&Rullo</h2>
          <p class="subtitle">Gestionale Artigiano Imbianchino & Decoratore</p>
        </div>

        <div *ngIf="errorMessage" class="error-msg">
          <span class="material-icons" style="font-size: 18px;">error_outline</span>
          <span>{{ errorMessage }}</span>
        </div>

        <form (ngSubmit)="onLogin()">
          <div class="form-group">
            <label>Username / Email</label>
            <input type="text" [(ngModel)]="email" name="email" required placeholder="admin" />
          </div>

          <div class="form-group">
            <label>Password</label>
            <input type="password" [(ngModel)]="password" name="password" required placeholder="admin" />
          </div>

          <button type="submit" class="btn-primary btn-block" [disabled]="loading">
            <span>{{ loading ? 'Accesso in corso...' : 'Accedi al Gestionale' }}</span>
            <span class="material-icons">arrow_forward</span>
          </button>
        </form>

        <div class="demo-info">
          <span class="material-icons">key</span>
          <p>Credenziali Demo: <strong>admin</strong> / <strong>admin</strong></p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .login-container { 
      display: flex; 
      justify-content: center; 
      align-items: center; 
      min-height: 100vh; 
      background: var(--bg-main); 
      padding: 20px;
      box-sizing: border-box;
    }
    
    .login-card { 
      background: var(--surface); 
      padding: 44px 36px; 
      border-radius: var(--radius); 
      box-shadow: var(--shadow-lg); 
      border: 1px solid var(--border);
      width: 100%; 
      max-width: 420px; 
      position: relative;
      overflow: hidden;
    }

    .brand-header {
      text-align: center;
      margin-bottom: 30px;
    }

    .brand-logo {
      width: 108px;
      height: 108px;
      background: var(--surface);
      border-radius: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px auto;
      box-shadow: 0 14px 32px rgba(200, 90, 50, 0.35);
      border: 1px solid var(--border);
      overflow: hidden;
    }
    .brand-logo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    h2 { 
      margin: 0; 
      color: var(--text-main); 
      font-size: 26px; 
      font-weight: 800;
    }

    .subtitle { 
      color: var(--text-muted); 
      margin: 6px 0 0 0; 
      font-size: 13px; 
      font-weight: 500;
    }

    .form-group { margin-bottom: 22px; }

    .btn-block {
      width: 100%;
      padding: 14px;
      font-size: 15px;
      margin-top: 10px;
    }

    .error-msg { 
      background: rgba(225, 29, 72, 0.1); 
      color: var(--danger); 
      padding: 12px; 
      border-radius: var(--radius-sm); 
      margin-bottom: 20px; 
      font-size: 13px; 
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .demo-info { 
      margin-top: 28px; 
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 12px; 
      color: var(--text-muted); 
      border-top: 1px solid var(--border); 
      padding-top: 18px; 
    }
    .demo-info p { margin: 0; }
    .demo-info .material-icons { font-size: 16px; color: var(--primary); }
  `]
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  loading = false;
  errorMessage = '';

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  onLogin() {
    this.loading = true;
    this.errorMessage = '';
    this.authService.login({ email: this.email, password: this.password }).subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.loading = false;
        this.errorMessage = err.error?.error || 'Errore durante il login';
      }
    });
  }
}
